export default "__VITE_ASSET__UuNJWJRi__"